module.exports = __webpack_public_path__ + "img/bc-step-2.341c9029.png";